import { EKeyCode } from '@/enums/e_key_code';
import { use_shortcut_down } from '@/hooks/shortcuts/use_shortcut_down';
import { CALLBACK_keyboard_event } from '@/types/types';

interface PROPS {
  key_codes: EKeyCode[];
  on_shortcut_pressed: CALLBACK_keyboard_event;
}

export function WATCHER_SHORTCUT__base({ key_codes, on_shortcut_pressed }: PROPS) {
  use_shortcut_down(key_codes, on_shortcut_pressed);

  return null;
}
